module.exports = __webpack_public_path__ + "static/assets/5b5f9e2da0e8e92ac097d7c78e138623.png";